let timeout;
const elementsToFadeIn = document.querySelectorAll(
    'main.content > .container-fluid > *.section > .headline, .section-wrapper > *'
);

// On page load:
fadeElementsInAndOut();
// again after waiting a bit, just to be sure:
setTimeout(function () {
    fadeElementsInAndOut();
}, 500);

function fadeElementsInAndOut() {
    [...elementsToFadeIn].forEach((el) => {
        if (window.scrollY >= el.offsetTop + el.offsetHeight + document.querySelector('.header').offsetHeight) {
            // element is fully above what user sees
            el.classList.add('fadedOut');
            el.classList.add('fadedOutUp');
        } else if (el.offsetTop > window.scrollY + window.innerHeight) {
            // element is fully below what user sees
            el.classList.add('fadedOut');
            el.classList.add('fadedOutDown');
        } else if (window.scrollY + window.innerHeight >= el.offsetTop) {
            // element is at least party in what user sees
            el.classList.remove('fadedOut');
            el.classList.remove('fadedOutUp');
            el.classList.remove('fadedOutDown');
        }
    });
}

function timeoutFadeElements() {
    if (!timeout) {
        timeout = setTimeout(function () {
            timeout = null;
            fadeElementsInAndOut();
        }, 100);
    }
}

// On resize and scroll:
window.addEventListener('scroll', timeoutFadeElements, false);
window.addEventListener('resize', timeoutFadeElements, false);
